import { ThemeMode } from '../context/ThemeContext';
import { getChartTheme as getDSTokens } from '../styles/tokens';

// Extended chart theme that includes additional series colors for specific use cases
export type ChartTheme = {
  axis: string;
  grid: string;
  neutral: string;
  primary: string;
  tooltipBg: string;
  tooltipFg: string;
  cardBg: string;
  cardFg: string;
  series: {
    school: string;
    municipality: string;
    national: string;
    reference: string;
    goal: string;
    // Additional series for specific charts
    band: string;
    girls: string;
    boys: string;
    rankingHighlight: string;
    rankingMuted: string;
    rankingLow: string;
    rankingMid: string;
    rankingHigh: string;
  };
};

// Legacy function for backward compatibility - now uses design system tokens
export function chartTheme(mode?: ThemeMode): ChartTheme {
  const isDark = mode === 'dark' || (mode === undefined && typeof document !== 'undefined' && document.documentElement.classList.contains('dark'));
  const dsTheme = getDSTokens(isDark);
  
  // Extend the design system theme with additional series colors
  return {
    ...dsTheme,
    neutral: isDark ? 'hsl(210 8% 60%)' : 'hsl(215 20% 65%)',
    primary: isDark ? 'hsl(152 75% 57%)' : 'hsl(160 84% 39%)',
    cardBg: isDark ? 'hsl(240 5% 12%)' : 'hsl(0 0% 100%)',
    cardFg: isDark ? 'hsl(210 40% 96%)' : 'hsl(222 47% 11%)',
    series: {
      ...dsTheme.series,
      // Additional series colors for specific use cases
      band: isDark ? 'rgba(255, 255, 255, 0.18)' : '#d4d4d8',
      girls: isDark ? '#FF5C5C' : '#dc2626',
      boys: isDark ? '#4DA6FF' : '#2563eb',
      rankingHighlight: isDark ? '#4ade80' : '#2e7d4d',
      rankingMuted: isDark ? '#6b7280' : '#9ca3af',
      rankingLow: isDark ? '#dc2626' : '#ef4444',
      rankingMid: isDark ? '#eab308' : '#facc15',
      rankingHigh: isDark ? '#4ade80' : '#22c55e',
    },
  };
}
